import {
	ContentBlock,
	FlexGap,
	FlexJustify,
	GenericLoader,
	Padding,
	useLayout,
	useTranslation,
} from '@ukpostbox/frontend-framework';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons/faCheckCircle';
import { faNote } from '@fortawesome/pro-solid-svg-icons/faNote';
import React from 'react';
import { useMailbox } from '../../../../Mailboxes/Providers/NewMailboxProvider';
import { useMailboxesStore } from '../../../../Mailboxes/Providers/Stores/MailboxesStore';

function MailItemNotesMeta() {
	const { t } = useTranslation();
	const { isTiny, isSmall, isMedium } = useLayout();

	const { UpdateMailNote, mailItemData } = useMailbox();

	const mailItemRequiresTopUp = useMailboxesStore((state) => state.mailItemRequiresTopUp);
	const mailNote = useMailboxesStore((state) => state.mailNote);

	return (
		<ContentBlock
			title={t('mailItem.labels.notes')}
			content={
				<div className={`inline-single-input ${mailNote.success ? 'inline-success' : ''}`}>
					<textarea
						defaultValue={mailItemData?.note}
						rows={isTiny || isSmall || isMedium ? 5 : 10}
						readOnly={mailNote.updating || mailItemRequiresTopUp}
						onBlur={(e: any) =>
							mailItemRequiresTopUp ? null : UpdateMailNote(e.target.value, mailItemData?.note || '')
						}
					/>

					{(mailNote.updating || mailNote.data) && (
						<div className='overlay-loader fill-container'>
							{mailNote.updating && <GenericLoader />}
							{mailNote.success && <FontAwesomeIcon icon={faCheckCircle} />}
						</div>
					)}
				</div>
			}
			iconContent={{ icon: faNote, iconSpacing: FlexGap.Small, iconSize: 'lg' }}
			padding={Padding.ExtraSmall}
			stacked={isTiny || isSmall || isMedium}
			justify={FlexJustify.Start}
		/>
	);
}

export { MailItemNotesMeta };
